<style scoped>
    .navigation-wrap{
        height: 100%;
        color: #fff;
        /*font-size: 14px;*/
    }
    .navigation-wrap .collapse-block{
        /*height: 36px;*/
        color: #fff;
        text-align: center;
        /*line-height: 36px;*/
        /*background-color: #232f38;*/
        cursor: pointer;
        padding: 3px;
    }
    .navigation-wrap .collapse-block i{
        display: inline-block;
        width: 18px;
        height: 15px;
        background: url("../../assets/icon/zan.png");
    }
    .navigation-wrap .collapse-block.appCollapsed i{
        background: url("../../assets/icon/zan_2.png");
        width: 15px;
        height: 18px;
    }
    .navigation-wrap .collapse-block i:hover{
        color: #fff;
    }
    .navigation-wrap ul, .navigation-wrap p{
        margin: 0;
        padding: 0;
    }
    .navigation-wrap li {
        list-style: none;
        cursor: pointer;
        /*line-height: 36px;*/
        user-select: none;
        /*color: #969fa9;*/
        /*background-color: #1c262d;*/
        /*color: #afb9c3;*/
    }
    .navigation-wrap li.topNav>p:hover {
        background-color: #42485b !important;
        color: #afb9c3;
    }

    .navigation-wrap li.cur i{
        color: #fff;
    }
    .navigation-wrap li .icon {
        transition: transform 0.28s ease-in-out;
    }
    .navigation-wrap li .icon.bottom{
        transform: rotate(90deg);
    }
    .navigation-wrap li .menu-icon{
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-bottom: -4px;
    }
    .navigation-wrap li .menu-icon.user{
        background: url("../../assets/icon/menu2.png") no-repeat;
    }
    .navigation-wrap li .menu-icon.device{
        background: url("../../assets/icon/menu1.png") no-repeat;
    }
    .navigation-wrap li .menu-icon.status{
        background: url("../../assets/icon/menu3.png") no-repeat;
    }
    .navigation-wrap li p{
        padding-left: 24px;
        white-space: nowrap;
    }
    .navigation-wrap li p span {
        margin-left: 7px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 104px;
        display: inline-block;
        height: 36px;
        line-height: 36px;
        vertical-align: middle;

    }
    .navigation-wrap li li{
        /*background-color: #2e3244;*/
        /*background-color: #182026;*/
    }
    .navigation-wrap li li li {
        /*background-color: #373c4f;*/
        background-color: #272932;
    }
    .navigation-wrap li li i.dot{
        background: url("../../assets/icon/spot.png") no-repeat;
        display: inline-block;
        width: 9px;
        height: 9px;
        margin-bottom: -2px;
    }
    .dk>p:hover{
        background-color: #3877d6;
        color: #fff;
    }
    .dk>p:hover i.dot, .navigation-wrap li li.cur i.dot{
        background: url("../../assets/icon/spot-white.png") no-repeat;
    }
    .navigation-wrap li li p{
        padding-left: 34px;
    }
    .navigation-wrap li li p span{
        margin-left: 2px;
        /*font-size: 14px;*/
    }
    .navigation-wrap li li.cur {
        background-color: #286ed6 !important;
        color: #fff;
    }
    .navigation-wrap.appCollapsed li{
        padding: 0;
        text-align: center;
    }
    .navigation-wrap.appCollapsed li p{
        padding:0;
    }
    .navigation-wrap.appCollapsed li span{
        display: none;
    }
    .navigation-content {
        height: calc(100% - 40px);
    }

</style>
<style>
    .navigation-content .el-scrollbar__wrap {
        overflow-x: hidden !important;
    }
</style>
<template>
    <div class="navigation-wrap" :style="{fontSize:fontSize}" :class="{'appCollapsed':$root.app.settings.asideFolded}" v-if="componentShow">
        <div class="collapse-block" :style="{backgroundColor:collColor,'height':collHeight,'line-height':collHeight}" @click="appCollapsedToggle()"  :class="{'appCollapsed':$root.app.settings.asideFolded}">
            <i></i>
        </div>
        <div class="navigation-content">
            <el-scrollbar style="height: 100%;">
                <ul>
                    <li  v-for="(nav,index) in menuList" :key="index" v-if="!nav.isVisible" class="topNav" @click="goPath(nav.visitUrl)" :style="{color:color,'background-color':liBg,'line-height':lineHeight}" :class="$root.app.settings.asideColor">
                        <el-tooltip v-show="$root.app.settings.asideFolded" effect="dark" placement="right">
                            <div slot="content">{{menu[nav.menuNo2]}}</div>
                            <p v-if="nav.childrenMenus && nav.childrenMenus.length > 0" @click.stop="subNavToggle(nav,index)">
                                <i class="menu-icon" :class="nav.iconUrl" v-if="nav.iconUrl"></i>
                                <span>{{menu[nav.menuNo2]}}</span>
                            </p>
                            <p v-else>
                                <i class="menu-icon" :class="nav.iconUrl" v-if="nav.iconUrl"></i>
                                <span>{{menu[nav.menuNo2]}}</span>
                            </p>
                        </el-tooltip>
                        <p v-if="nav.childrenMenus && nav.childrenMenus.length > 0" v-show="!$root.app.settings.asideFolded" @click.stop="subNavToggle(nav,index)">

                            <i class="menu-icon" :class="nav.iconUrl" v-if="nav.iconUrl"></i>
                            <span :title="menu[nav.menuNo2]">{{menu[nav.menuNo2]}}</span>
                            <i class="icon fa fa-angle-right" :class="{'bottom': curSubNav === index}" v-if="nav.childrenMenus&&nav.childrenMenus.length>0"></i>
                        </p>
                        <p v-else v-show="!$root.app.settings.asideFolded" >

                            <i class="menu-icon" :class="nav.iconUrl" v-if="nav.iconUrl"></i>
                            <span :title="menu[nav.menuNo2]">{{menu[nav.menuNo2]}}</span>
                            <i class="icon fa fa-angle-right" :class="{'bottom': curSubNav === index}" v-if="nav.childrenMenus&&nav.childrenMenus.length>0"></i>
                        </p>
                        <transition name="drop"
                                    v-on:enter="enter"
                                    v-on:leave="leave">
                            <ul v-show="curSubNav === index">
                                <li v-for="(subItem,subIndex) in nav.childrenMenus" class="dk" v-if="!subItem.isVisible" :key="subIndex" @click="goPath(subItem.visitUrl)" :style="{'background-color':liliBg}" :class="{'cur': subItem.visitUrl && $route.path.indexOf(subItem.visitUrl)>-1}">
                                    <el-tooltip v-show="$root.app.settings.asideFolded" effect="dark" placement="right">
                                        <div slot="content">{{menu[subItem.menuNo2]}}</div>
                                        <p v-if="subItem.childrenMenus&&subItem.childrenMenus.length>0" @click.stop="subItemNavToggle(subItem)">
                                            <i class="dot"></i>
                                            <span>{{menu[subItem.menuNo2]}}</span>
                                        </p>
                                        <p v-else>
                                            <i class="dot"></i>
                                            <span>{{menu[subItem.menuNo2]}}</span>
                                        </p>
                                    </el-tooltip>
                                    <p v-if="subItem.childrenMenus&&subItem.childrenMenus.length>0" v-show="!$root.app.settings.asideFolded" @click.stop="subItemNavToggle(subItem)">
                                        <i class="dot"></i>
                                        <span :title="menu[subItem.menuNo2]">{{menu[subItem.menuNo2]}}</span>
                                        <i class="icon fa fa-angle-right" :class="{'bottom': curSubItemNav === subItem.id}" v-if="subItem.childrenMenus&&subItem.childrenMenus.length>0"></i>
                                    </p>
                                    <p v-else v-show="!$root.app.settings.asideFolded">
                                        <i class="dot"></i>
                                        <span :title="menu[subItem.menuNo2]">{{menu[subItem.menuNo2]}}</span>
                                    </p>
                                    <transition name="drop"
                                                v-on:enter="enter"
                                                v-on:leave="leave">
                                        <ul v-show="curSubItemNav === subItem.id">
                                            <li v-for="(subItem1,sub1Index) in subItem.childrenMenus" class="dk" v-if="!subItem1.isVisible" :key="sub1Index" @click="goPath(subItem1.visitUrl)" :class="{'cur': subItem1.visitUrl && $route.path.indexOf(subItem1.visitUrl)>-1}">
                                                <el-tooltip v-show="$root.app.settings.asideFolded" effect="dark" placement="right">
                                                    <div slot="content">{{menu[subItem1.menuNo2]}}</div>
                                                    <p >
                                                        <i class="dot"></i>
                                                        <span style="margin-left: 30px">{{menu[subItem1.menuNo2]}}</span>
                                                    </p>
                                                </el-tooltip>
                                                <p v-show="!$root.app.settings.asideFolded">
                                                    <!--<i class="dot"></i>-->
                                                    <span style="margin-left: 15px" :title="menu[subItem1.menuNo2]">{{menu[subItem1.menuNo2]}}</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </transition>
                                </li>
                            </ul>
                        </transition>
                    </li>
                </ul>
            </el-scrollbar>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import Velocity from "velocity-animate";
    export default {
        name: 'Navigation',
        props: {
            menuList: {
                type: Array,
                default: []
            },
            color: {
                type: String,
                default: '#ffffff'
            },
            liBg:{
                type: String,
                default: '#10161a'
            },
            lineHeight:{
                type: String,
                default: '36px'
            },
            liliBg:{
                type: String,
                default: '#364856'
            },
            collColor:{
                type: String,
                default: '#232f38'
            },
            collHeight:{
                type: String,
                default: '36px'
            },
            fontSize:{
                type: String,
                default: '14px'
            }
        },
        data() {
            return {
                curSubNav: -1,
                curSubItemNav: -1,
                componentShow:true
            }
        },
        computed:{
            menu(){
                return this.$t('menu')
            }
        },
        watch: {
            $route(to) {
                /* let pathArr = this.$route.path.split('/');
                 let topNavPath = '';
                 if (pathArr) {
                     topNavPath = `/${pathArr[1]}`;
                 }
                 for (let i =0;i<this.menuList.length;i++) {
                     if (this.menuList[i].visitUrl === topNavPath) {
                         this.curSubNav = i;
                         break;
                     }
                 }*/
            }
        },
        methods: {
            appCollapsedToggle() {
                this.$root.app.settings.asideFolded = !this.$root.app.settings.asideFolded
            },
            subNavToggle(nav,index) {
                if (!(nav.childrenMenus&&nav.childrenMenus.length>0)) return;
                if (this.curSubNav === index) {
                    this.curSubNav = -1;
                } else {
                    this.curSubNav = index;
                }
            },
            subItemNavToggle(nav) {
                if (!(nav.childrenMenus && nav.childrenMenus.length > 0)) return;
                if (this.curSubItemNav === nav.id) {
                    this.curSubItemNav = -1;
                } else {
                    this.curSubItemNav = nav.id;
                }
            },
            goPath(path){
                console.log(path)
                if(path){
                    this.$router.push({path: path});
                }
            },
            // animate
            enter: function (el, done) {
                Velocity(el, 'slideDown', {duration: 280, complete: done})
            },
            leave: function (el, done) {
                Velocity(el, 'slideUp', {
                    duration:280, complete: done
                })
            },
        },
        beforeDestroy(){
            this.componentShow = false;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/navigation/index.vue